import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { from, Observable } from "rxjs";
import { Page } from "src/app/util/page";
import { AuthorService } from "../../author/author.service";
import { Genre } from "../../genre/genre";
import { GenreService } from "../../genre/genre.service";
import { PublisherService } from "../../publisher/publisher.service";
import { InitSearch } from "../../../util/search/init-search";
import { Reference } from "../reference";
import { ReferenceService } from "../reference.service";
import { AbstractReferenceSearchComponent } from "./abstract-reference-search.component";
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from "@angular/router";
import { mergeMap, tap, toArray } from "rxjs/operators";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { AuthorSearchCriteriaComponent } from "./criteria/author-search-criteria.component";
import { GenreSearchCriteriaComponent } from "./criteria/genre-search-criteria.component";
import { PublisherSearchCriteriaComponent } from "./criteria/publisher-search-criteria.component";
import { SearchReferenceRequest } from "../search-reference-request";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NewReferenceComponent } from "../new-reference/new-reference.component";

@Component({
  selector: 'reference-search',
  templateUrl: './reference-search.component.html',
  styleUrls: ['./reference-search.component.css'],
})
export class ReferenceSearchComponent extends AbstractReferenceSearchComponent implements OnInit {

  @Input()
  public routed = true;

  @Input()
  public implicitFilters = new Map<Criteria, string>();

  @ViewChild(AuthorSearchCriteriaComponent)
  authorCriteria!: AuthorSearchCriteriaComponent;

  @ViewChild(GenreSearchCriteriaComponent)
  genreCriteria!: GenreSearchCriteriaComponent;

  @ViewChild(PublisherSearchCriteriaComponent)
  publisherCriteria!: PublisherSearchCriteriaComponent;

  constructor(
    private modalService: NgbModal,
    referenceService: ReferenceService,
    private genreService: GenreService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(referenceService);
  }

  protected customizeSearchRequest(searchReferenceRequest: SearchReferenceRequest): void {

  }

  ngOnInit(): void {
    if (!this.routed) {
      this.referenceService.onReferencesRefresh().subscribe(initSearch => this.onSearchInit(initSearch));

      return;
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.refreshChildComponent(this.authorCriteria, this.genreCriteria, this.publisherCriteria);

    if (this.routed) {
      this.route.queryParamMap.subscribe(queryParam => setTimeout(() => this.searchWithQueryParam(queryParam)));
    }
  }

  public openNewReferenceModal() {
    this.modalService.open(NewReferenceComponent, {
      backdrop: 'static',
      keyboard: false
    });
  }

  public refresh() {
    if (this.routed) {
      this.router.navigate(["/inventory/reference"], { queryParams: this.getQueryParams() });
    } else {
      this.search();
    }
  }

  public searchWithQueryParam(paramMap: ParamMap) {
    from(paramMap.getAll("genre")).pipe(
      mergeMap(themaCode => this.genreService.findByThemaCode(themaCode)),
      tap(genre => AbstractReferenceSearchComponent.GENRE_CRITERIA.addGenre(genre)),
      toArray(),
      tap(_ => this.initWithParamMap(paramMap)),
    ).subscribe(_ => this.search());
  }
}